import {
  AnchorButtonProps as BlueprintAnchorButtonProps,
  PopoverPosition as BlueprintPopoverPosition,
} from '@blueprintjs/core';
import {
  Popover2 as BlueprintPopover2,
  Popover2Props as BlueprintPopover2Props,
} from '@blueprintjs/popover2';
import classNames from 'classnames';
import * as React from 'react';

import { BreadcrumbButton } from 'bones/design-system/components/breadcrumb/BreadcrumbButton';

export type BreadcrumbMenuProps = Pick<
  BlueprintAnchorButtonProps,
  'disabled'
> & {
  'data-testid'?: never;
  boundary?: BlueprintPopover2Props['boundary'];
  className?: string;
  isOpen?: boolean;
  menu: React.ReactElement;
  onInteraction?: BlueprintPopover2Props['onInteraction'];
  popoverClassName?: string;
  position?: BlueprintPopoverPosition;
  testId?: string;
};

export const BreadcrumbMenu: React.VFC<BreadcrumbMenuProps> = ({
  boundary,
  className,
  disabled,
  isOpen: controlledIsOpen,
  menu,
  onInteraction,
  popoverClassName,
  position = BlueprintPopoverPosition.BOTTOM_RIGHT,
  testId,
}) => {
  const [isOpen, setIsOpen] = React.useState(controlledIsOpen ?? false);
  return (
    <div className={classNames(className, 'vb-breadcrumb-menu')}>
      <BlueprintPopover2
        boundary={boundary}
        content={menu}
        disabled={disabled}
        isOpen={controlledIsOpen ?? isOpen}
        minimal
        onInteraction={(nextIsOpen, evt) => {
          onInteraction?.(nextIsOpen, evt);
          if (controlledIsOpen === undefined) {
            setIsOpen(nextIsOpen);
          }
        }}
        popoverClassName={classNames(
          popoverClassName,
          'vb-breadcrumb-menu-popover',
          `vb-popover-position--${position}`
        )}
        portalContainer={
          (process.env.NODE_ENV === 'test' &&
            document.getElementById('vet-bones-root')) ||
          // istanbul ignore next
          undefined
        }
        position={position}
      >
        <BreadcrumbButton active={isOpen} disabled={disabled} testId={testId}>
          ...
        </BreadcrumbButton>
      </BlueprintPopover2>
    </div>
  );
};
